import { useContext, useEffect, useRef, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
// @ts-expect-error Could not find a declaration file for module PropertyGroupRecord
import PropertyGroupRecord from 'customer-data-objects/property/PropertyGroupRecord';
import { useEditorActions } from '../../../hooks/useEditorActions';
import { useFieldOptions } from '../../../hooks/useFieldOptions';
import SegmentationFiltersInstanceContext from '../../../state/SegmentationFiltersInstanceContext';
import DataExplorerEmptyState from './general/DataExplorerEmptyState';
import EditorFieldOption from '../../editor/EditorFieldOption';
import EditorFieldLoadMoreOption from '../../editor/EditorFieldLoadMoreOption';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterFamilySelectOptions = props => {
  const {
    filterFamily,
    isLoadingFields,
    searchString,
    propertyTypeFilter
  } = props;
  const {
    isLoadingFields: isLoadingFieldsInitial
  } = useContext(SegmentationFiltersInstanceContext);
  const [loadingMore, setLoadingMore] = useState(false);
  const {
    selectField
  } = useEditorActions();
  const {
    options: fieldOptions
  } = useFieldOptions(filterFamily, searchString, undefined, propertyTypeFilter);

  // This useEffect tracks the number of field options to set keep the loading
  // state updated
  const prevOptionsLength = useRef(fieldOptions.length);
  useEffect(() => {
    if (prevOptionsLength.current < fieldOptions.length && loadingMore) {
      setLoadingMore(false);
    }
    prevOptionsLength.current = fieldOptions.length;
  }, [fieldOptions.length, loadingMore]);
  if (isLoadingFieldsInitial || isLoadingFields) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.fieldSelectFlow.loadingFields"
      }),
      showLabel: true,
      size: "small"
    });
  }
  const hasNoOptions = fieldOptions.length === 0;
  if (hasNoOptions) {
    return /*#__PURE__*/_jsx(DataExplorerEmptyState, {
      message: "customerDataFiltersUI.dataExplorer.emptyState.noOptions"
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [fieldOptions.map((entry, index) => {
      if (entry instanceof PropertyGroupRecord) {
        return /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(TruncateString, {
            paddingInlineStart: "400",
            children: entry.get('displayName')
          })
        }, `${index}-${entry.get('name')}`);
      }
      return /*#__PURE__*/_jsx(EditorFieldOption, {
        field: entry,
        filterFamily: filterFamily,
        onClick: () => selectField(filterFamily, entry)
      }, `${index}-${entry.get('name')}`);
    }), /*#__PURE__*/_jsx(EditorFieldLoadMoreOption, {
      filterFamily: filterFamily,
      isLoadingMore: loadingMore,
      onLoadMore: setLoadingMore,
      searchString: searchString
    })]
  });
};
export default FilterFamilySelectOptions;